import type { Copy } from "../types";

export const es: Copy = {
    seo: {
      title: "Calculadora de edad del vehículo | por año y mes",
      description:
        "Comprueba la edad exacta de un vehículo por su año y mes de fabricación. Ve años, meses, días, total de días y hitos en una sola calculadora.",
      keywords: [
        "calculadora edad vehículo",
        "edad del coche",
        "edad del vehículo por año",
        "calculadora de fabricación",
        "comprobador de edad del vehículo",
        "calculadora RC",
      ],
      faq: [
        {
          question: "¿Qué hace esta calculadora?",
          answer:
            "Calcula la edad exacta de un vehículo según el año y mes de fabricación seleccionados.",
        },
        {
          question: "¿Por qué hay un mes opcional?",
          answer:
            "El mes hace el cálculo más preciso. Si lo omites, se usa enero del año elegido.",
        },
        {
          question: "¿Puedo elegir un año o mes futuro?",
          answer:
            "No. Los años futuros están bloqueados y los meses futuros se desactivan cuando el año elegido es el actual.",
        },
      ],
    },
    headerTagline: "Utilidad vehicular",
    headerTitle: "Calculadora de edad",
    reset: "Reiniciar",
    switchToLight: "Modo claro",
    switchToDark: "Modo oscuro",
    languageLabel: "Idioma",
    languageEnglish: "Inglés",
    languageHindi: "Hindi",
    heroEyebrow: "Edad del coche, clara",
    heroTitle: "Una herramienta limpia para la edad del vehículo.",
    heroDescription:
      "Elige el año de fabricación. Añade un mes solo si quieres mayor precisión.",
    yearSelectLabel: "Año de fabricación",
    monthSelectLabel: "Mes de fabricación",
    includeMonthLabel: "Incluir mes específico para más precisión",
    includeMonthNote: "Si no incluyes un mes, se usa enero para el cálculo.",
    yearOnlyBadge: "Solo año",
    yearMonthBadge: "Año + mes",
    yearPlaceholder: "Elegir año",
    monthPlaceholder: "Elegir mes",
    inputTitle: "Año de fabricación",
    inputLabel: "Año de fabricación",
    blockedDateNote: "Los años futuros están bloqueados.",
    result: "Resultado",
    vehicleAgeLead: "Tu vehículo es",
    asOfToday: "A fecha de hoy",
    years: "Años",
    months: "Meses",
    days: "Días",
    totalDays: (count) => `${count.toLocaleString("en-IN")} días en total`,
    ageLabels: {
      almostNew: "Casi nuevo",
      modern: "Moderno",
      mature: "Maduro",
      classic: "Clásico",
    },
    estimatedValue: {
      high: "Alto potencial de reventa",
      healthy: "Buena retención de valor",
      moderate: "Depreciación moderada",
      collector: "Puede crecer el interés de coleccionista",
    },
    maintenanceTitle: "Mantenimiento",
    maintenance: {
      routine: "Servicio rutinario y cuidado OEM",
      watch: "Vigila frenos, fluidos y neumáticos",
      plan: "Planifica revisiones y piezas de desgaste",
      specialized: "El mantenimiento especializado gana valor",
    },
    registrationTitle: "Registro",
    registration: {
      collector: "Puede optar a tratamiento de coleccionista en algunas regiones",
      classic: "En algunas regiones puede aplicar registro clásico",
      standard: "Espera renovaciones estándar y controles regionales",
      regular: "Normalmente aplica un registro regular",
    },
    upcomingMilestoneTitle: "Próximo hito",
    milestoneTimelineTitle: "Cronología de hitos",
    milestoneRemaining: ({ label, days }) => `${label} en ${days.toLocaleString("es-ES")} días`,
    reached: "Alcanzado",
    upcoming: "Próximo",
    allMilestonesReachedTitle: "Todos los hitos listados ya se alcanzaron",
    allMilestonesReachedBody: "Este vehículo ya superó el rango de hitos mostrado.",
    copySummary: "Copiar resumen",
    shareResult: "Compartir resultado",
    resetMessage: "Calculadora reiniciada",
    summaryCopied: "Resumen copiado al portapapeles",
    clipboardFailed: "Error al acceder al portapapeles",
    emptyTitle: "Elige un año de fabricación para ver el desglose",
    emptyDescription:
      "Verás edad exacta, días totales, notas de mantenimiento, estado clásico y hitos cuando elijas un año.",
    shareTitle: "Calculadora de edad del vehículo",
    summary: ({ label, years, months, days, asOf }) =>
      `Mi coche fue fabricado en ${label} y tiene ${years} años, ${months} meses y ${days} días a fecha de ${asOf}.`,
    milestones: {
      1: { label: "Primer año", note: "Útil para garantía y servicio." },
      3: { label: "Tres años", note: "Punto común para reventa y cambios de valor." },
      5: { label: "Cinco años", note: "Buen momento para presupuestar mantenimiento." },
      10: { label: "Diez años", note: "Los componentes antiguos merecen atención." },
      15: { label: "Quince años", note: "En muchas regiones empieza el trato clásico." },
      25: { label: "Veinticinco años", note: "Atractivo para coleccionistas e importación." },
    },
  };
